<template>
  <el-select
    v-model="selected"
    size="small"
    filterable
    remote
    clearable
    :allow-create="canCreate"
    :default-first-option="allowCreate"
    @change="handleChange"
    :remote-method="requestData"
    :loading="loading"
    placeholder="搜索并选择人员"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name + (item.name_en ? `（${item.name_en}）` : '')"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { userList } from '../../service/getData'
import { isMobile } from '@/util/index'

export default {
  props: {
    val: '',
    allResource: {
      type: Boolean,
      default: false,
    },
    role: {
      type: String,
      default: '',
    },
    allowCreate: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      } else if (this.allowCreate && typeof v === 'string') {
        this.selected = v
      }
    },
    role: function (v) {
      this.requestData('all')
    },
  },
  data() {
    return {
      isMobile,
      selected: '',
      lists: [],
      loading: false,
      searchQuery: '',
    }
  },
  computed: {
    canCreate() {
      return (
        this.allowCreate &&
        !this.loading &&
        this.searchQuery.trim() !== '' &&
        this.lists.length === 0
      )
    },
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        },
      )
    })
  },
  created() {
    if (this.allowCreate && typeof this.val === 'string' && this.val) {
      this.selected = this.val
    } else if (this.val > 0) {
      this.requestDefaultUser()
    }
  },
  methods: {
    handleChange() {
      let selected = parseInt(this.selected) || 0
      if (this.allowCreate && typeof this.selected === 'string') {
        this.selected = this.selected.trim()
        selected = this.selected || 0
      }
      this.$emit('change', selected)
    },
    async requestDefaultUser() {
      let res = await userList({
        user_id: this.val,
        all_resource: this.allResource,
      })
      this.lists = res.data.list
      this.selected = this.val
    },
    async requestData(query) {
      this.searchQuery = query == 'all' ? '' : query
      if (query !== '') {
        if (query == 'all') {
          query = ''
        }
        this.loading = true
        let data = {
          query: query,
          all_resource: this.allResource,
          role_name: this.role,
          page: 0,
          size: 20,
          status: 1,
        }
        let res = await userList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        if (this.role) {
          this.requestData('all')
        } else {
          this.lists = []
        }
      }
    },
  },
}
</script>
